import React from 'react';
import '../styles/GameStatus.css';

const GameStatus = ({ gameState, inCheck, isCheckmate, isStalemate, winner }) => {
  const currentPlayer = gameState.side_to_move === 'white' ? 'White' : 'Black';
  
  let statusMessage = '';
  let statusClass = '';
  
  if (isCheckmate) {
    statusMessage = `Checkmate! ${winner === 'white' ? 'White' : 'Black'} wins!`;
    statusClass = 'checkmate';
  } else if (isStalemate) {
    statusMessage = 'Stalemate! Game is a draw.';
    statusClass = 'stalemate';
  } else if (inCheck) {
    statusMessage = `${currentPlayer} is in check!`;
    statusClass = 'check';
  } else {
    statusMessage = `${currentPlayer} to move`;
    statusClass = 'normal';
  }

  return (
    <div className={`game-status ${statusClass}`}>
      <div className="status-message">{statusMessage}</div>
      <div className="game-info">
        <span>Move #{gameState.fullmove_number}</span>
      </div>
    </div>
  );
};

export default GameStatus;
